<template>
  <div class="mt-1 relative">
    <div class="fixed inset-0" aria-hidden="true" v-if="open">
      <div class="absolute inset-0" v-on:click="open = !open"></div>
    </div>

    <input
      type="text"
      :id="resId"
      :name="resId"
      class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
      aria-haspopup="listbox"
      aria-expanded="true"
      aria-labelledby="listbox-label"
      :placeholder="placeholder"
      :aria-placeholder="placeholder"
      v-on:click="open = !open"
      v-model="searchText"
    />

    <span
      class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
    >
      <svg
        class="h-5 w-5 text-gray-400"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </span>

    <transition
      leave-active-class="transition ease-in duration-100"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <ul
        class="absolute mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm z-10"
        tabindex="-1"
        role="listbox"
        aria-labelledby="listbox-label"
        aria-activedescendant="listbox-option-3"
        v-if="open && dataArr.length > 0"
      >
        <li
          class="text-gray-900 select-none relative py-2 pl-3 pr-9 hover:bg-gray-100 cursor-pointer"
          id="listbox-option-0"
          role="option"
          v-for="(item, i) in dataArr"
          v-bind:key="i"
          v-on:click="emitItemToParent(item)"
        >
          <span class="font-normal block truncate">
            {{ item[textKey] }}
          </span>
        </li>
      </ul>
    </transition>
  </div>
</template>
<script>
export default {
  name: "SearchListBox",
  props: {
    resId: {
      type: String
    },
    dataArr: {
      type: Array,
      default: []
    },
    textKey: {
      type: String
    },
    enabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "blue"
    },
    placeholder: {
      type: String
    }
  },
  data() {
    return {
      searchText: null,
      open: false
    };
  },
  created() {
    const onEscape = e => {
      if (this.open && e.keyCode === 27) {
        this.open = false;
      }
    };

    document.addEventListener("keydown", onEscape);

    this.$once("hook:destroyed", () => {
      document.removeEventListener("keydown", onEscape);
    });
  },
  watch: {
    searchText(text) {
      this.$emit("onSearch", text);
    }
  },
  methods: {
    emitItemToParent(item) {
      this.open = !this.open;
      this.$emit("onSelect", item);
      this.searchText = null;
    }
  }
};
</script>
